import { render, staticRenderFns } from "./toDoQuestion.vue?vue&type=template&id=332c4bde&scoped=true&"
import script from "./toDoQuestion.vue?vue&type=script&lang=tsx&"
export * from "./toDoQuestion.vue?vue&type=script&lang=tsx&"
import style0 from "./toDoQuestion.vue?vue&type=style&index=0&id=332c4bde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c4bde",
  null
  
)

export default component.exports